var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaudiRiyalWht(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,13.4c-.2.5-.4,1-.4,1.6l4.5-1c.2-.5.4-1,.4-1.6l-4.5,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,11c.2-.5.4-1,.4-1.6l-3.5.8v-1.5l3.1-.7c.2-.5.4-1,.4-1.6l-3.5.8V1.7c-.5.3-1,.7-1.4,1.2v4.5l-1.4.3V1c-.5.3-1,.7-1.4,1.2v5.9l-3.2.7c-.2.5-.4,1-.4,1.6l3.6-.8v1.9l-3.8.8c-.2.5-.4,1-.4,1.6l4-.9c.3,0,.6-.3.8-.5l.7-1.1c0-.1,0-.3,0-.4v-1.7l1.4-.3v3s4.5-1,4.5-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiRiyalWht);
export default __webpack_public_path__ + "static/media/SaudiRiyal-WHT.17bcab9dededc75e27f61238bfaff0a2.svg";
export { ForwardRef as ReactComponent };